import { ImportExportType } from '@/components/ImportExportHistory/type';
import { useTranslation } from '@/i18n';
import { FC, memo } from 'react';

type Props = {
  type: ImportExportType;
};

export const TypeCell: FC<Props> = memo(({ type }) => {
  const { t } = useTranslation();

  const label =
    type === 'import'
      ? t('import_export_history_type_import')
      : t('import_export_history_type_export');

  return <span>{label}</span>;
});

TypeCell.displayName = 'TypeCell';
